module.exports = __webpack_public_path__ + "img/Male.ca83b9ce.png";